export async function uploadToS3(signedUrl, fileBlob) {
  try {
    const response = await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": fileBlob.type,
      },
      body: fileBlob,
    });

    if (!response.ok) {
      console.error("Upload failed with status:", response.status);
    }
    return response;
  } catch (err) {
    console.error("Upload error:", err);
    return err;
  }
}
